/**
 * Normalizes a layer URL by removing any trailing slashes.
 *
 * This utility ensures consistency when comparing or storing URLs
 * by stripping one or more trailing slashes from the end of the string.
 * If the input is `null` or `undefined`, it returns `null`.
 */

export function normalizeLayerUrl(url?: string | null): string | null {
  return url ? url.replace(/\/+$/, "") : null;
}